import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { ModalConfirmComponent, dialogData } from './modal-confirm/modal-confirm.component';


@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  constructor(private dialog: MatDialog) {

  }



  public show(data: dialogData) {
    return this.dialog.open(ModalConfirmComponent, { closeOnNavigation: true, disableClose: false, data: data }).afterClosed()
  }



}
